import { render, staticRenderFns } from "./StudyActivityPanel.vue?vue&type=template&id=483ce325&scoped=true&"
import script from "./StudyActivityPanel.vue?vue&type=script&lang=js&"
export * from "./StudyActivityPanel.vue?vue&type=script&lang=js&"
import style0 from "./StudyActivityPanel.vue?vue&type=style&index=0&id=483ce325&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483ce325",
  null
  
)

export default component.exports